{
  "common": {
    "cancel": "Avbryt",
    "login": "Logg inn",
    "backToLogin": "Gå til innlogging",
    "copy": "Kopier",
    "copied": "Kopiert",
    "show": "Vis",
    "hide": "Skjul",
    "language": "Språk",
    "norwegian": "Norsk",
    "english": "Engelsk",
    "selectPlaceholder": "Velg …",
    "noOptions": "Ingen treff",
    "createOption": "Legg til «{{value}}»",
    "somethingWentWrong": "Noe gikk galt. Prøv igjen, eller kontakt administrator."
  },
  "a11y": {
    "skipToContent": "Hopp til hovedinnhold"
  },
  "nav": {
    "login": "Logg inn",
    "adLogin": "AD-innlogging",
    "logout": "Logg ut",
    "apiToken": "API-token",
    "statistics": "Statistikk",
    "users": "Brukere",
    "role": "Roller",
    "mappings": "Koblinger",
    "application": "Applikasjoner",
    "registration": "Registrering",
    "menu": "Meny",
    "profile": "Min profil",
    "help": "Hjelp",
    "toggleNavigation": "Veksle navigasjon"
  },
  "help": {
    "title": "Hjelp og brukerveiledning",
    "intro": "Veiledning for operatører som registrerer og forvalter brukere, koblinger og tilganger i Dekon SSO. Søk, eller åpne et tema for å lese mer.",
    "search": "Søk i hjelpen …",
    "expandAll": "Utvid alle",
    "collapseAll": "Lukk alle",
    "noResults": "Ingen treff for søket ditt.",
    "note": "Merk",
    "warning": "Obs",
    "updated": "Sist oppdatert"
  },
  "footer": {
    "version": "Versjon",
    "tagline": "Dekon SSO"
  },
  "theme": {
    "switchToLight": "Bytt til lyst tema",
    "switchToDark": "Bytt til mørkt tema"
  },
  "validation": {
    "required": "Dette feltet er påkrevd.",
    "email": "Skriv en gyldig e-postadresse.",
    "emailWithDomain": "Skriv fullt brukernavn med domene, f.eks. navn@domene.no",
    "minLength": "Verdien er for kort.",
    "maxLength": "Verdien er for lang.",
    "passwordWeak": "Passordet må ha minst 8 tegn, med store og små bokstaver og minst ett tall.",
    "passwordsMustMatch": "Passordene er ikke like.",
    "digitsOnly": "Skriv kun siffer.",
    "phone": "Skriv et gyldig telefonnummer.",
    "baseUrl": "Må være http(s)://domene-eller-ip uten skråstrek på slutten (f.eks. http://192.168.168.213:19999).",
    "path": "Må starte med skråstrek, f.eks. /smartstore2."
  },
  "login": {
    "title": "Dekon SSO",
    "subtitle": "Logg inn med brukernavn og passord.",
    "adSubtitle": "Logg inn med din Active Directory-konto.",
    "username": "Brukernavn",
    "usernamePlaceholder": "navn@domene.no",
    "password": "Passord",
    "passwordPlaceholder": "Passordet ditt",
    "submit": "Logg inn",
    "forgotPassword": "Glemt passord?",
    "captchaHint": "Bekreft at du ikke er en robot for å fortsette.",
    "error": "Feil brukernavn eller passord. Prøv igjen.",
    "expired": "Økten din er utløpt. Logg inn på nytt."
  },
  "twofa": {
    "title": "Tofaktor-bekreftelse",
    "subtitle": "Velg hvordan du vil bekrefte innloggingen.",
    "authy": "Authy-app (anbefalt)",
    "authyHint": "Åpne Authy-appen på mobilen din og godkjenn forespørselen.",
    "emailNotRecommended": "E-post (anbefales ikke)",
    "appKey": "Authy-nøkkel",
    "copyKey": "Kopier nøkkel",
    "rememberDevice": "Husk denne enheten",
    "rememberDeviceHint": "Du slipper tofaktor på denne enheten en periode framover.",
    "emailSent": "Vi har sendt en kode på e-post. Skriv koden under for å bekrefte.",
    "code": "Engangskode",
    "codePlaceholder": "6-sifret kode",
    "verify": "Bekreft",
    "resendEmail": "Send e-post på nytt",
    "attemptsLeft": "{{count}} forsøk igjen før du må bekrefte med captcha.",
    "error": "Bekreftelsen gikk ikke gjennom. Prøv igjen, eller velg en annen metode."
  },
  "forgot": {
    "title": "Glemt passord?",
    "subtitle": "Skriv e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.",
    "email": "E-postadresse",
    "submit": "Send tilbakestillingslenke",
    "success": "Vi har sendt en e-post med tilbakestillingslenke til den registrerte adressen din."
  },
  "setPassword": {
    "resetTitle": "Tilbakestill passord",
    "resetSubtitle": "Velg et nytt passord.",
    "confirmTitle": "Bekreft konto",
    "confirmSubtitle": "Sett et passord for å aktivere kontoen din.",
    "password": "Nytt passord",
    "confirmPassword": "Bekreft passord",
    "submitReset": "Tilbakestill passord",
    "submitConfirm": "Sett passord"
  },
  "passwordFeedback": {
    "ok": "Passordet er endret. Du kan nå logge inn.",
    "badRequest": "Noe gikk galt under endring av passord. Prøv igjen.",
    "unauthorized": "Du har ikke tilgang til å gjøre denne endringen.",
    "userNotFound": "Fant ikke brukeren.",
    "default": "Noe gikk galt under endring av passord. Prøv igjen."
  },
  "admin": {
    "stats": {
      "title": "Statistikk",
      "description": "Et raskt overblikk over aktiviteten i dag, hentet fra telemetri.",
      "activeToday": "Unike aktive brukere hittil i dag",
      "activeTodayHint": "Distinkte innloggede brukere sett siden midnatt (lokal tid) – samme bruker telles én gang, også ved gjenbrukt økt.",
      "mostUsedType": "Mest brukt applikasjonstype",
      "mostUsedBadge": "mest brukt",
      "usersAndRequests": "{{users}} brukere · {{requests}} kall",
      "otherType": "Øvrig",
      "legendApp": "{{requests}} kall ({{pct}} %) · {{users}} brukere",
      "legendOther": "{{requests}} kall ({{pct}} %) · innlogging, API, statiske filer m.m.",
      "usagePct": "{{pct}} % bruk",
      "usageOf": "{{active}} av {{total}} registrerte brukere",
      "usersWord": "brukere",
      "mappingTitle": "Brukere per applikasjon",
      "mappingDesc": "Fordeling av koblinger på tvers av applikasjoner (fra databasen).",
      "withMapping": "Med kobling",
      "withoutMapping": "Uten kobling",
      "aspAggregate": "ASP – alle instanser",
      "aspNote": "unike brukere på tvers av {{apps}} ASP-instanser (samlet — overlapper appene under)",
      "singleApps": "Enkeltapplikasjoner",
      "topNote": "Topp {{shown}} av {{total}} applikasjoner.",
      "hourlyTitle": "Aktivitet i dag · per time (lokal tid)",
      "monthlyTitle": "Aktive brukere per dag · denne måneden",
      "monthlyNote": "Søyler (aktive brukere) vises fra da per-bruker-sporing ble slått på. Kall-linjen dekker hele perioden. Dagens søyle er lysere fordi dagen ikke er ferdig.",
      "seriesUsers": "Aktive brukere",
      "seriesCalls": "Kall",
      "noUsage": "Ingen applikasjonsbruk registrert i dag ennå.",
      "updatedAt": "Oppdatert {{time}}",
      "refresh": "Oppdater",
      "loading": "Laster statistikk …",
      "error": "Kunne ikke laste statistikken. Prøv igjen.",
      "unavailable": "Statistikk er ikke tilgjengelig i dette miljøet."
    },
    "role": {
      "title": "Roller",
      "description": "Endre rollen til en bruker blant forhåndsdefinerte roller. Nye roller kan ikke legges til.",
      "user": "Bruker",
      "newRole": "Ny rolle",
      "submit": "Oppdater rolle",
      "success": "Brukerrollen er oppdatert.",
      "roleExists": "Brukeren har allerede denne rollen.",
      "loadError": "Kunne ikke laste data. Prøv å laste siden på nytt.",
      "error": "Noe gikk galt under oppdatering av rollen."
    },
    "token": {
      "title": "API-token",
      "description": "Generer token for API-brukeren. Tokenet gir tilgang til API-et, så det må håndteres og deles sikkert.",
      "email": "E-post",
      "connectionString": "Tilkoblingsstreng",
      "generate": "Generer token",
      "tokenLabel": "Generert token",
      "securityNote": "Kopier tokenet nå og oppbevar det trygt – det vises ikke igjen.",
      "error": "Kunne ikke generere token. Prøv igjen."
    },
    "application": {
      "title": "Applikasjoner",
      "description": "Registrer en applikasjon. Dette trengs sjelden – stort sett bare ved nye kunder.",
      "sync": "Synkroniser fra konfigurasjon",
      "syncSuccess": "Applikasjoner synkronisert fra konfigurasjon.",
      "syncNothing": "Ingen nye applikasjoner å synkronisere.",
      "or": "– eller –",
      "type": "Applikasjonstype",
      "smartstore": "Smartstore",
      "jasper": "Jasper",
      "name": "Applikasjonsnavn",
      "namePlaceholder": "Eksempel: Dekon ASP – Lekia Asker – 10034",
      "baseUrl": "Base-URL",
      "baseUrlPlaceholder": "Eksempel: http://192.168.168.213:10034",
      "path": "Sti",
      "pathPlaceholder": "Eksempel: /smartstore2",
      "register": "Registrer",
      "added": "Applikasjonen er lagt til.",
      "nameExists": "Applikasjonsnavnet finnes allerede.",
      "error": "Kunne ikke legge til applikasjonen.",
      "selectApp": "Velg applikasjon",
      "typeLabel": "Type",
      "attachedUsers": "{{count}} bruker(e) tilknyttet",
      "update": "Oppdater",
      "updated": "Applikasjonen er oppdatert.",
      "updateError": "Kunne ikke oppdatere applikasjonen.",
      "delete": "Slett applikasjon",
      "deleteTitle": "Slett applikasjon",
      "confirmDelete": "Sletting av en applikasjon kan skape store problemer og kan ikke angres. Skriv applikasjonsnavnet under for å bekrefte.",
      "confirmLabel": "Skriv «{{name}}» for å bekrefte",
      "proceed": "Slett applikasjon",
      "deleted": "Applikasjonen er slettet.",
      "deleteError": "Kunne ikke slette applikasjonen.",
      "deleteHasUsers": "Kan ikke slette: det finnes brukere tilknyttet denne applikasjonen. Fjern koblingene først.",
      "loadError": "Kunne ikke laste applikasjoner.",
      "mappedUsersTitle": "Tilknyttede brukere",
      "mappedUsersHint": "Velg brukere og fjern koblingen deres til denne applikasjonen. Brukerne beholder kontoene sine.",
      "selectAll": "Velg alle",
      "noMappedUsers": "Ingen brukere er tilknyttet denne applikasjonen.",
      "loadUsersError": "Kunne ikke laste brukerne.",
      "removeSelected": "Fjern valgte ({{count}})",
      "removeMappingsTitle": "Fjern brukerkoblinger",
      "confirmRemoveMappings": "Fjerne {{count}} brukerkobling(er) fra «{{name}}»? Brukerne beholder kontoene sine, men mister tilgangen til denne applikasjonen.",
      "removeMappingsProceed": "Fjern koblinger",
      "mappingsRemoved": "{{count}} kobling(er) fjernet.",
      "removeMappingsError": "Kunne ikke fjerne koblingene."
    }
  },
  "mappings": {
    "title": "Koblinger",
    "smartstoreTab": "SmartStore",
    "reportingTab": "Rapportering",
    "modeAdd": "Legg til",
    "modeEdit": "Rediger",
    "delete": "Slett kobling",
    "deleteTitle": "Slett kobling",
    "confirmDelete": "Er du sikker på at du vil slette denne koblingen? Dette kan ikke angres.",
    "proceed": "Slett",
    "deleted": "Koblingen er slettet.",
    "deleteError": "Kunne ikke slette koblingen.",
    "smartstore": {
      "title": "SmartStore-kobling",
      "description": "Legg til eller rediger SmartStore-koblinger for en SSO-bruker. Pass på at informasjonen er korrekt for å unngå problemer senere.",
      "selectUser": "Velg bruker å redigere",
      "instance": "SmartStore-instans",
      "userName": "Brukernavn",
      "userNamePlaceholder": "bruker@domene.no",
      "user": "SmartStore-bruker (CS10)",
      "userPassword": "Passord (CS10)",
      "companyId": "Firma (CS00)",
      "companyPassword": "Firmapassord (CS00)",
      "storeId": "Butikk-ID/nummer (BD88)",
      "addJasper": "Legg til Jasper-kobling",
      "jasperServer": "Velg Jasper-server",
      "register": "Registrer",
      "update": "Oppdater",
      "registered": "Brukerapplikasjonen er registrert!",
      "updated": "SmartStore-koblingen er oppdatert!",
      "userNotFound": "Fant ikke brukeren.",
      "userExists": "Brukeren finnes allerede.",
      "domainInvalid": "Domenet er ikke riktig.",
      "mappingExists": "Det finnes allerede en kobling for denne brukeren.",
      "serverError": "Serverfeil. Prøv igjen.",
      "loadError": "Kunne ikke laste koblingen for valgt bruker.",
      "updateError": "Kunne ikke oppdatere SmartStore-koblingen."
    },
    "jasper": {
      "title": "Rapporterings-registrering",
      "description": "Legg til Jasper-rapporteringskoblinger for en bruker.",
      "instance": "Jasper-serverinstans",
      "user": "Brukernavn",
      "orgId": "Jasper organisasjons-ID",
      "ssoUserName": "SSO-brukernavn",
      "jasperUser": "Jasper-brukernavn",
      "password": "Jasper-passord",
      "register": "Registrer",
      "update": "Oppdater",
      "added": "Koblingen er lagt til.",
      "updated": "Jasper-koblingen er oppdatert!",
      "mappingExists": "Det finnes allerede en kobling for denne brukeren.",
      "addError": "Kunne ikke legge til koblingen. Prøv igjen.",
      "updateError": "Kunne ikke oppdatere Jasper-koblingen.",
      "loadError": "Kunne ikke laste Jasper-koblingen for valgt bruker.",
      "instanceLoadError": "Kunne ikke laste Jasper-applikasjoner. Prøv å laste siden på nytt."
    }
  },
  "register": {
    "tabRegister": "Registrer",
    "tabImport": "Importer",
    "tabResend": "Send bekreftelse på nytt",
    "tab24Seven": "24SevenOffice",
    "title": "Registrer lokal bruker",
    "description": "Administrer lokale brukere – legg til, rediger og slett.",
    "selectUser": "Velg bruker",
    "selectCustomer": "Velg kunde",
    "firstName": "Fornavn",
    "lastName": "Etternavn",
    "countryCode": "Landskode",
    "phoneNumber": "Mobilnummer",
    "phone": "Mobilnummer",
    "email": "E-post",
    "sendMeEmail": "Send samme lenke til meg",
    "useNewMenu": "Bruk ny meny-kobling",
    "registerUser": "Registrer bruker",
    "saveChanges": "Lagre endringer",
    "deleteUser": "Slett bruker",
    "selectCustomerFirst": "Velg kunde først.",
    "registered": "Registreringen var vellykket! Sjekk e-posten for å bekrefte kontoen.",
    "updated": "Oppdateringen var vellykket! Sjekk e-posten for å bekrefte kontoen.",
    "updatedNoEmail": "Oppdateringen var vellykket!",
    "deleted": "Brukeren er slettet!",
    "invalidForm": "Ugyldige verdier. Fyll ut skjemaet og prøv igjen.",
    "emailExists": "E-posten finnes allerede hos en annen bruker.",
    "userExists": "Bruker eller e-post finnes allerede.",
    "loadError": "Kunne ikke laste brukere. Prøv å laste siden på nytt.",
    "deleteError": "Kunne ikke slette brukeren.",
    "confirmDeleteTitle": "Slett bruker",
    "confirmDelete": "Er du sikker på at du vil slette denne brukeren?",
    "proceed": "Fortsett"
  },
  "import": {
    "title": "Importer brukere",
    "description": "Importer lokale SSO-brukere og koblinger fra en CSV-fil. Bruk det avtalte filformatet.",
    "clickUpload": "Klikk for å laste opp CSV",
    "remove": "Fjern",
    "submit": "Importer valgte",
    "synced": "Dataene er importert!",
    "serverError": "Det oppstod en serverfeil.",
    "mapToSso": "Koble til SSO",
    "stopped": "Importen ble stoppet – ingen rader ble importert. Rett radene under (radnummer + årsak) og kjør hele fila på nytt.",
    "invalidEmail": "Ugyldig e-postadresse.",
    "invalidPhone": "Ugyldig telefonnummer.",
    "required": "Påkrevd.",
    "pickValid": "Velg en gyldig verdi fra lista.",
    "fixErrors": "Rett de røde feltene før import ({{count}} rad(er) har feil).",
    "colRow": "Rad",
    "colUser": "Bruker",
    "colApp": "Applikasjon",
    "colError": "Feil"
  },
  "resend": {
    "title": "Send bekreftelses-e-post på nytt",
    "description": "Velg brukeren som skal få en ny bekreftelseslenke på e-post. Søk på navn, e-post eller telefon.",
    "email": "E-post",
    "sendMeLink": "Send lenken til meg også",
    "submit": "Send e-post på nytt",
    "sent": "Bekreftelses-e-post sendt på nytt.",
    "alreadyConfirmed": "E-posten er allerede bekreftet.",
    "error": "Det oppstod en feil. E-posten kunne ikke sendes."
  },
  "sync24": {
    "title": "24SevenOffice",
    "description": "Synkroniser kunder fra 24SevenOffice-API-et til lokal database. Kun «Business»-kunder med ID mellom 10000–15000 beholdes.",
    "sync": "Synkroniser kunder",
    "synced": "Kunder synkronisert.",
    "failed": "Synkronisering mislyktes."
  },
  "users": {
    "title": "Lokale SSO-brukere",
    "search": "Søk",
    "searchPlaceholder": "Søk navn, e-post, telefon eller kunde …",
    "loading": "Laster brukere …",
    "exportCodeword": "Eksport-kodeord",
    "delete": "Slett",
    "deleteTitle": "Slett bruker",
    "confirmDelete": "Slett {{name}} og alle koblinger og data som hører til brukeren? Dette kan ikke angres.",
    "deleted": "Brukeren er slettet.",
    "deleteError": "Kunne ikke slette brukeren.",
    "deleteSelected": "Slett valgte ({{count}})",
    "bulkDeleteTitle": "Slett brukere",
    "confirmBulkDelete": "Slett {{count}} brukere og alle koblinger og data som hører til dem? Dette kan ikke angres.",
    "bulkDeleted": "{{count}} brukere slettet.",
    "bulkDeleteError": "Kunne ikke slette brukerne.",
    "selectUser": "Velg bruker",
    "selectAllUsers": "Velg alle synlige",
    "filterEmail": "E-post",
    "filterConfirmed": "E-post bekreftet",
    "confirmedAll": "Alle",
    "confirmedYes": "Bekreftet",
    "confirmedNo": "Ikke bekreftet",
    "createdAfter": "Opprettet etter",
    "customers": "Kunder",
    "loginAfter": "Innlogget etter",
    "download": "Last ned CSV",
    "error": "Det oppstod en feil. Kunne ikke hente brukerdata.",
    "noUsers": "Ingen brukere å vise.",
    "count": "{{count}} brukere",
    "colName": "Navn",
    "colEmail": "E-post",
    "colPhone": "Telefon",
    "colLastLogin": "Siste innlogging",
    "colCustomer": "Kunde",
    "colCreated": "Opprettet",
    "colConfirmed": "E-post bekreftet"
  },
  "home": {
    "title": "Dekon SSO",
    "welcome": "Velkommen",
    "description": "Her finner du tjenestene og funksjonene du har tilgang til.",
    "noServices": "Ingen tjenester er registrert på denne brukeren. Kontakt administrator for å få tilgang.",
    "smartstoreGroup": "SmartStore & Min Butikk",
    "reportingGroup": "Rapportering",
    "smartstore": "Smartstore",
    "minButikk": "Min Butikk",
    "reporting": "Rapportering",
    "selectInstallationFirst": "Velg en SmartStore-installasjon først.",
    "selectReportingFirst": "Velg en rapporteringsinstans først."
  },
  "profile": {
    "title": "Min profil",
    "email": "E-post",
    "dangerZone": "Faresone",
    "deleteHint": "Sletting fjerner kontoen din og alle data og koblinger som hører til. Dette kan ikke angres.",
    "deleteAccount": "Slett min konto",
    "confirmDelete": "Er du helt sikker? Kontoen din og alt som hører til slettes for godt.",
    "proceed": "Slett kontoen min",
    "deleteError": "Kunne ikke slette kontoen. Prøv igjen, eller kontakt administrator.",
    "adManaged": "Denne kontoen administreres i Active Directory og kan ikke slettes herfra."
  }
}
